/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionGoToAddDataSource';

const ActionGoToAddDataSourceManager: ActionManagerFn<
  'ActionGoToAddDataSource'
> = (platform: Platform): ActionManager<'ActionGoToAddDataSource'> => {
  return {
    ...baseActionManager(platform, 'ActionGoToAddDataSource'),
    defaultValue,
    props: {
      ...baseActionProps,
    },
    name: 'Go To Add DataSource',
    icon: { iconName: 'external-link' },
    description: `**Overview**<br/>
The "Go To Add DataSource" action is a specialized, system-level navigation component identified primarily for internal use within the platform. Its specific function is to initiate a navigation event that directs the user to the interface for adding or configuring a new Data Source.<br/><br/>
This component is designed with a fixed behavior, leveraging the platform's internal routing logic rather than requiring developer configuration. It is structurally minimal, inheriting all standard behaviors from the base action manager without introducing any component-specific properties or validation logic.

**Key Features**<br/>
* **Internal Utility:** Explicitly described as a "CloudIO Internal Action," suggesting it is intended for use within the application builder or specific administrative workflows rather than general end-user navigation.
* **Fixed Destination:** Operates without target parameters, implying the destination (the Add Data Source screen) is hardcoded or resolved internally by the platform.
* **Zero Configuration:** Relies entirely on baseActionProps, requiring no specific inputs from the developer to function.

**Properties**<br/>
* **Base Properties:** This component utilizes ...baseActionProps exclusively, accepting only the standard configuration options available to all actions.

**Use Cases**<br/>
* **Builder Navigation:** Used within the platform's development environment to quickly redirect a developer to the data configuration panel.
* **System Workflows:** Part of a predefined setup wizard or administrative dashboard that routes users to creating data connections.`,
  };
};

export default ActionGoToAddDataSourceManager;
